<script lang="ts">
import { AlertTriangle } from 'lucide-vue'
export default {
  name: 'ServiceOrderWarnings',
  components: {
    AlertTriangle,
  },
  props: {
    serviceProvider: { type: Object, required: true },
    fromTime: { type: Date, required: true },
    categoryEditLimit: { type: Object, required: true },
  },
  computed: {
    hourDiff () {
      const now = new Date()
      const diffMs = this.fromTime.getTime() - now.getTime()
      return diffMs / (1000 * 60 * 60)
    },
    isWeekend () {
      const day = this.fromTime.getDay()
      return day === 0 || day === 6
    },
    warnings () {
      const warns = []

      if (this.serviceProvider.needs_manual_acceptance) {
        warns.push({
          text: this.$t('Services.Details.Warnings.NeedsManualAcceptance'),
        })
      }

      if (!this.serviceProvider.needs_manual_acceptance && this.serviceProvider.edit_limit_in_hours && this.hourDiff < this.serviceProvider.edit_limit_in_hours) {
        warns.push({
          text: this.$t('Services.Details.Warnings.ProviderEditLimitWarning', { hours: this.serviceProvider.edit_limit_in_hours }),
        })
      }

      if (!this.serviceProvider.needs_manual_acceptance && this.hourDiff < this.categoryEditLimit.limit) {
        warns.push({
          text: this.$t('Services.Details.Warnings.CategoryEditLimitWarning', { category: this.categoryEditLimit.name, hours: this.categoryEditLimit.limit }),
        })
      }

      if (this.serviceProvider.future_order_limit_in_days && (this.hourDiff / 24) > this.serviceProvider.future_order_limit_in_days) {
        warns.push({
          text: this.$t('Services.Details.Warnings.ProviderFutureOrderLimitWarning', { days: this.serviceProvider.future_order_limit_in_days }),
        })
      }

      if (!this.serviceProvider.accepts_weekend_orders && this.isWeekend) {
        warns.push({
          text: this.$t('Services.Details.Warnings.ProviderWeekendOrderWarning'),
        })
      }

      if (this.serviceProvider.order_warning) {
        warns.push({
          text: this.serviceProvider.order_warning,
        })
      }

      return warns
    },
  },
}
</script>
<template>
  <div class="mb-4">
    <div
      v-for="warning, i in warnings"
      :key="warning.text"
      class="rounded-lg border p-2 flex gap-2 border-amber-600 ring-2 ring-amber-200"
      :class="i === (warnings.length - 1) ? 'mb-4' : 'mb-2'"
    >
      <AlertTriangle class="m-1 w-5 h-5 text-amber-600 shrink-0" />
      <div>
        <h4 class="text-flexopus-black font-medium text-xs min-h-[1.75rem] flex items-center">
          {{ warning.text }}
        </h4>
      </div>
    </div>
  </div>
</template>
